import { CouponExistsInput, useCouponExistsQuery } from "@pathwright/graphql-client/src/generated"
import OrderDiscountForm, { OrderDiscountFormProps } from "./OrderDiscountForm"

export function useCouponExists(
  couponExistsInput: CouponExistsInput["path"] | CouponExistsInput["plan"]
) {
  const input = couponExistsInput
    ? "resourceId" in couponExistsInput
      ? {
          path: couponExistsInput
        }
      : "schoolSubscriptionPlanId" in couponExistsInput
      ? {
          plan: couponExistsInput
        }
      : undefined
    : undefined

  const { data, error } = useCouponExistsQuery({
    variables: { input },
    skip: !input
  })
  if (!input) return false
  // Don't spin the Register checkout CTA forever when the query errors
  // (common when GraphQL is contended by parallel e2e workers).
  if (error) return false
  return data ? data.couponExists === true : undefined
}

type ConditionalOrderDiscountFormProps = (
  | CouponExistsInput["path"]
  | CouponExistsInput["plan"]
) &
  OrderDiscountFormProps

function ConditionalOrderDiscountForm({
  applyDiscountCode,
  clearDiscountCode,
  searchParamKey,
  ...couponExistsInput
}: ConditionalOrderDiscountFormProps) {
  return useCouponExists(couponExistsInput) ? (
    <OrderDiscountForm
      applyDiscountCode={applyDiscountCode}
      clearDiscountCode={clearDiscountCode}
      searchParamKey={searchParamKey}
    />
  ) : null
}

export default ConditionalOrderDiscountForm
